export const normalizeClientSearchQuery = (value) => {
  if (value === null || value === undefined) return "";

  const query = String(value).trim();
  if (!query) return "";

  // Keep names, email addresses, and IDs intact; only strip display formatting
  // from queries that contain phone-number characters exclusively.
  return /^[+\d\s().-]+$/.test(query) ? query.replace(/\D/g, "") : query;
};
